export default __webpack_public_path__ + "locales/sl/Errors.json?hash=80e4a66465fa6ef31288a0c44fcce40c";